export function combineMsgs<T>(
  ...validationFuncs: {
    (value: T[keyof T], rest: T): string | string[] | boolean;
  }[]
) {
  return (value: T[keyof T], rest: T) => validationFuncs.map((fn) => fn(value, rest)).join('');
}
